import { Grid, GridItem, Skeleton } from "@chakra-ui/react";

function BookingSkeleton() {
  return (
    <Grid templateColumns="repeat(12, 1fr)" gap="1rem">
      <GridItem colSpan={8}>
        <Skeleton
          sx={{
            borderRadius: "0.5rem",
            height: "70vh",
            width: "100%",
          }}
        />
      </GridItem>
      <GridItem colSpan={4}>
        <Skeleton
          sx={{
            borderRadius: "0.5rem",
            height: "40vh",
            width: "100%",
          }}
        />
      </GridItem>
    </Grid>
  );
}

export default BookingSkeleton;
